<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="480"
    :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">审核历史</v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <!-- -->
        <v-timeline align-top dense>
          <v-timeline-item v-for="h in hist" :key="`hist-${h.dbid}`"
                           color="primary" small>
            <div>
              <p class="ma-0 pa-0">
                <v-chip small label style="margin: 0; padding: 0" slot="activator" class="ma-0 pa-0">
                  <strong>{{ h.srcStaName }}</strong>
                </v-chip>
                <strong>&nbsp;&#8594;&nbsp;</strong>
                <v-chip small label style="margin: 0; padding: 0" slot="activator" class="ma-0 pa-0">
                  <strong>{{ h.tgtStaName }}</strong>
                </v-chip>
              </p>
              <p class="ma-1 pa-0">{{ h.oprUsrName }} 【执行】 {{ h.actName }}</p>
              <p class="ma-1 pa-0" style="color:#01579b" v-if="h.message && h.message.length > 0">
                <strong>{{ h.message }}</strong>
              </p>
              <p class="ma-1 pa-0">{{ h.oprTime && h.oprTime.slice(0, 19).replace('T', ' ') }}</p>
            </div>
            <v-divider/>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="$emit('close')">关闭</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {width} from "chart.js/src/core/core.scale";

export default {
  model: {
    prop: 'visible',
    event: 'input'
  },

  props: ['visible', 'wfInst'],

  data() {
    return {}
  },

  computed: {
    hist() {
      if (this.wfInst) {
        return [{
          'dbid': this.wfInst.dbid,
          'actName':this.wfInst.actName,
          'srcStaName': this.wfInst.srcStaName,
          'tgtStaName': this.wfInst.tgtStaName,
          'oprUsrName': this.wfInst.oprUsrName,
          'oprTime': this.wfInst.oprTime,
          'message': this.wfInst.message,
        }].concat(this.wfInst.hist || [])
      }
      return []
    }
  },

  methods: {}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/global/wf/WfInstHist.vue